import React from 'react'

const ColumnLabel = ({label}:{label: string}) => (
    <span style={{'textTransform': 'uppercase', 'fontSize': '0.65rem', 'letterSpacing': '0.08em'}}>
        {label}
    </span>
)

export default ColumnLabel